export const PEDIDO_INTERNAL_MESSAGE_SEPARATOR = '\n\n━━ Mensaje interno ━━\n\n';

export function parsePedidoInternalMessages(notas) {
  const source = String(notas || '').trim();
  if (!source) return [];

  return source
    .split(PEDIDO_INTERNAL_MESSAGE_SEPARATOR)
    .map((block, index) => {
      const trimmed = String(block || '').trim();
      if (!trimmed) return null;

      const lines = trimmed.split('\n');
      const header = String(lines[0] || '').trim();
      const body = lines.slice(1).join('\n').trim();
      const match = header.match(/^(.+?)(?: \(([^)]+)\))? · (\d{2}\/\d{2}\/\d{4} \d{2}:\d{2} hs)$/);

      if (match && body) {
        const author = String(match[1] || '').trim();
        const lowAuthor = author.toLowerCase();
        const tone = lowAuthor.startsWith('admin')
          ? 'administracion'
          : (lowAuthor.startsWith('medico') || lowAuthor.startsWith('médico') || /^(dr|dra)\.?/.test(lowAuthor)
              ? 'medico'
              : 'legacy');
        return {
          id: `pedido-internal-${index}`,
          author,
          username: match[2] || '',
          timestamp: match[3],
          text: body,
          tone
        };
      }

      return {
        id: `pedido-internal-${index}`,
        author: 'Nota previa',
        username: '',
        timestamp: '',
        text: trimmed,
        tone: 'legacy'
      };
    })
    .filter(Boolean);
}